export const personalizationCallOut = {
  position: "relative",
};

export const callout =
  ({ backgroundColor, zIndex, position }) =>
  ({ isDesktop }) => {
    return {
      display: "flex",
      flexDirection: "column",
      backgroundColor,
      border: "1px solid #000000",
      boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.25)",
      borderRadius: "4px",
      position: "absolute",
      zIndex,
      transform: "translate(-50%, -50%)",

      ...(!isDesktop ? position.mobile : position.desktop),
    };
  };

export const disclaimerContainer = ({ isDesktop }) => ({
  borderRadius: "4px 4px 0px 0px",
  height: isDesktop ? "36px" : "18px",
  backgroundColor: "white",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const disclaimer = ({ isDesktop }) => ({
  padding: "10px",
  fontFamily: "roboto",
  fontSize: isDesktop ? "12px" : "10px",
  lineHeight: "1.4",
  letterSpacing: "0.1em",
  textAlign: "center",
  color: "grey7",
});

export const calloutImage = ({ backgroundImageUrl }) => ({
  backgroundImage: `url("${backgroundImageUrl}")`,
  backgroundPosition: "50% 50%",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  borderRadius: "0px 0px 1px 1px",
  flexGrow: "1",
  flexShrink: "1",
  position: "relative",
});

export const number = ({ isDesktop }) => ({
  color: "grey9",
  fontFamily: "diamanteefBoldItalic",
  fontSize: isDesktop ? "60px" : "30px",
  lineHeight: "0.8",
  letterSpacing: "0.01em",
  textTransform: "uppercase",
  textAlign: "center",
  width: "55px",

  position: "absolute",
  top: isDesktop ? "13px" : "4px",
  left: isDesktop ? "28px" : "6px",
});

export const text = ({ isDesktop }) => ({
  color: "grey9",
  fontFamily: "diamanteefBoldItalic",
  fontSize: isDesktop ? "20px" : "10px",
  lineHeight: "0.8",
  letterSpacing: "0.07em",
  textTransform: "uppercase",

  position: "absolute",
  top: isDesktop ? "42px" : "19px",
  left: isDesktop ? "87px" : "53px",
});

export const outerLabel = {
  position: "absolute",
  textTransform: "uppercase",
  bottom: "100%",
  mb: "10px",
};
